import { Product } from '../models/Product';
import { getProducts, getProductById } from '../services/productService';

export const fetchAllProducts = (): Product[] => {
  return getProducts();
};

export const fetchProductById = (id: number): Product | undefined => {
  return getProductById(id);
};

